export const PRICE_UNITS = [
    {value: 0, label: 'Per Item'},
    {value: 1, label: 'Per Gallon'},
    {value: 2, label: 'Per Square Foot'},
];
